import { types } from "../../types/types";

import { desSeleccionarAfiliadoNuevo } from "../preAfiliado/afiliado";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

const urlBase= process.env.REACT_APP_URL

export const traerPreafiliadoExternoPorCuil = (cuil) => async (dispatch, getState) => {
    try {
      dispatch(desSeleccionarAfiliadoNuevo());
      dispatch(startSpinner());
      const state = getState();
      const {usuarioAutogestion} =  state.userAutogestion;
      const response= await fetch(`${urlBase}/api/Preafiliados/traerDesdeServicio/${cuil}`,{headers: {'Content-Type': 'application/json','Authorization':'Bearer '+usuarioAutogestion.token}})
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const afiliado = await response.json();
        if (response.status !== 200) throw afiliado.errores;
          if(afiliado){
            if(afiliado.estado===0 || afiliado.estado===1 ){
              afiliado.cuil=cuil;
              dispatch({
                  type: types.consultaTraerAfiliadoPorCuil,
                  payload: afiliado,
                });
            }
          }
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log("Error Servicio Afip",err);
      dispatch(startAlerta(err.Msg, "warning", `¡Error!`));
    }
  };
  
